import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { languages, formatLanguageCode } from 'i18n/options';
import changeI18nLanguage from 'utils/i18n/changeLanguage';
import config from 'utils/config';
import useModalQueryParam from 'hooks/useModalQueryParam';

/* Actions */

import { useFetchUserProfile, useUpdateUserLanguage } from 'actions/userProfile';
import { useUpdateMyUserSettings } from 'actions/userSettings';
import { useFetchUserHelixAccess } from 'actions/users';

/* Components */

import Card from 'components/Card';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import Panel from 'components/Panel';
import FormField from 'components/FormField';
import CheckboxOption from 'components/CheckboxOption';
import RadioButtonOption from 'components/RadioButtonOption';
import EmptyStateController from 'components/EmptyStateController';
import Text from 'components/Text';
import { Select, Option } from 'components/Select';
import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import Stack from 'components/Stack';
import UserCalendarIntegration from 'components/UserCalendarIntegration';
import Flex, { Box } from 'components/Flex';
import ProfileEditor from './editor';
import UnsubscribeConfirmationModal from './UnsubscribeConfirmationModal';
var SECTION_WIDTH = 600;
function UserSettingsPage() {
  var _userProfile$first_na, _userProfile$last_nam, _userProfile$settings2;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _useFetchUserHelixAcc = useFetchUserHelixAccess(),
    helixAccessData = _useFetchUserHelixAcc.data,
    isHelixAccessLoading = _useFetchUserHelixAcc.isLoading;
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data,
    isLoading = _useFetchUserProfile.isLoading,
    isError = _useFetchUserProfile.isError;
  var _useUpdateUserLanguag = useUpdateUserLanguage(),
    updateUserLanguage = _useUpdateUserLanguag.updateUserLanguage;
  var _useModalQueryParam = useModalQueryParam('unsubscribe-confirmation'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasUnsubscribeConfirmationModal = _useModalQueryParam2[0],
    toggleUnsubscribeConfirmationModal = _useModalQueryParam2[1];
  function changeLanguage(lang) {
    updateUserLanguage(lang);
    changeI18nLanguage(lang);
  }
  var _useUpdateMyUserSetti = useUpdateMyUserSettings(),
    updateUserSettings = _useUpdateMyUserSetti.updateUserSettings,
    isUpdatingSettings = _useUpdateMyUserSetti.isLoading;
  function updateSettings(key, value) {
    updateUserSettings(_objectSpread(_objectSpread({}, userProfile === null || userProfile === void 0 ? void 0 : userProfile.settings), {}, _defineProperty({}, key, value)));
  }
  var isLangEnglish = i18n.language.substring(0, 2) === 'en';
  var selectedLanguage = formatLanguageCode(i18n.language);
  var notificationChannels = {
    all: {
      label: 'profile_settings_notifications_channel_all'
    },
    email: {
      label: 'profile_settings_notifications_channel_email'
    },
    ms_teams: {
      label: 'profile_settings_notifications_channel_ms_teams'
    }
  };
  var hasMsTeamsId = config.hasMsTeamsId,
    areCommentsEnabled = config.enableComments;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    visuallyHidden: true
  }, t('navbar_user_settings')), /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isLoading,
    isError: isError
  }, /*#__PURE__*/React.createElement(PageSection, {
    maxWidth: SECTION_WIDTH
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(ProfileEditor, {
    initialFirstName: (_userProfile$first_na = userProfile === null || userProfile === void 0 ? void 0 : userProfile.first_name) !== null && _userProfile$first_na !== void 0 ? _userProfile$first_na : '',
    initialLastName: (_userProfile$last_nam = userProfile === null || userProfile === void 0 ? void 0 : userProfile.last_name) !== null && _userProfile$last_nam !== void 0 ? _userProfile$last_nam : '',
    email: userProfile === null || userProfile === void 0 ? void 0 : userProfile.email,
    userCustomFields: userProfile === null || userProfile === void 0 ? void 0 : userProfile.userCustomFields
  }))), /*#__PURE__*/React.createElement(PageSection, {
    maxWidth: SECTION_WIDTH
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    id: "select_language_title"
  }, t('profile_choose_language')), !isLangEnglish && /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    as: "p",
    lang: "en"
  }, t('profile_choose_language', {
    lng: 'en'
  }))), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Select, {
    id: "profile_language_dropdown",
    labelledById: "select_language_title",
    size: "medium",
    value: selectedLanguage,
    onChange: changeLanguage
  }, languages.map(function (lang) {
    return /*#__PURE__*/React.createElement(Option, {
      key: lang.value,
      value: lang.value
    }, lang.title);
  }))))), (hasMsTeamsId || areCommentsEnabled) && /*#__PURE__*/React.createElement(PageSection, {
    maxWidth: SECTION_WIDTH
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, t('profile_settings_notifications'))), hasMsTeamsId && /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('profile_settings_notifications_channel')
  }, Object.entries(notificationChannels).map(function (_ref) {
    var _userProfile$settings;
    var _ref2 = _slicedToArray(_ref, 2),
      channel = _ref2[0],
      label = _ref2[1].label;
    return /*#__PURE__*/React.createElement(RadioButtonOption, {
      key: "notification_channel_".concat(channel, "_radiobttn"),
      label: t(label),
      id: channel,
      disabled: isUpdatingSettings,
      value: channel,
      checked: channel === (userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$settings = userProfile.settings) === null || _userProfile$settings === void 0 ? void 0 : _userProfile$settings.notification_channel),
      onChange: function onChange(event) {
        return updateSettings('notification_channel', event.target.value);
      }
    });
  }))), areCommentsEnabled && /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('profile_settings_comment_subscriptions')
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(CheckboxOption, {
    label: t('profile_settings_autosubscription'),
    id: "auto-subscription-toggle",
    disabled: isUpdatingSettings,
    checked: userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$settings2 = userProfile.settings) === null || _userProfile$settings2 === void 0 ? void 0 : _userProfile$settings2.autoSubscribe,
    onChange: function onChange(e) {
      return updateSettings('autoSubscribe', !!e.target.checked);
    }
  }), /*#__PURE__*/React.createElement(Flex, {
    gap: "xs",
    align: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    overflow: 'wrap'
  }, /*#__PURE__*/React.createElement(Text, null, t('profile_settings_unsubscribe_comment_subscriptions'))), /*#__PURE__*/React.createElement(Box, {
    grow: true
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    onClick: toggleUnsubscribeConfirmationModal
  }, t('actions_unsubscribe'))))))))), config.userCalendarIntegration && !isHelixAccessLoading && (helixAccessData === null || helixAccessData === void 0 ? void 0 : helixAccessData.hasAccess) && /*#__PURE__*/React.createElement(PageSection, {
    maxWidth: SECTION_WIDTH
  }, /*#__PURE__*/React.createElement(UserCalendarIntegration, null)), hasUnsubscribeConfirmationModal && /*#__PURE__*/React.createElement(UnsubscribeConfirmationModal, {
    closeModal: toggleUnsubscribeConfirmationModal
  })));
}
export default UserSettingsPage;